import React, {useState, useCallback, useEffect} from 'react'
import {useTranslation} from 'react-i18next';
import SMCModalButtonContainer from '../../components/core/SMCModal/SMCModalButtonContainer';
import SMCModalBody from '../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../components/Simple/SMCButton';
import SMCModal from '../../components/core/SMCModal';
import {ObjectTypes} from '../../api/consts';
import Api from '../../api/SMPFetchHelper';
import SMCLabel from '../../components/Simple/SMCLabel';
import {CommunityGetListSchema} from '../../api/DBSchema/Community';
import {SMCSelect, SMCOption} from '../../components/Simple/SMCSelect';
import {PlanGetSchema} from '../../api/DBSchema/Plan';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useSMCErrorHandler} from '../../utils/errorUtils';

const communitySchema = PlanGetSchema.pages.vpnCommunity.communityDataSchema;

function JoinCommunityModal({
    isOpen,
    onRequestClose,
    onSuccess,
    defaultObject,
    isGateway=false
}) {
    const { t } = useTranslation();
    const { getErrorMessage } = useSMCErrorHandler();

    const [isDataLoading, setIsDataLoading] = useState(false);
    const [communityNameList, setCommunityNameList] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);

    const [community, setCommunity] = useState('');
    const [isCenter, setIsCenter] = useState(false);

    const loadData = useCallback(() => {
        setIsDataLoading(true);
        Api.fetchObjectList(ObjectTypes.COMMUNITY, 0)
        .then((resp) => {
            if (Array.isArray(resp.data.data)) {
                setCommunityNameList(resp.data.data.map(comm => comm[CommunityGetListSchema.name]));
            } else {
                setCommunityNameList([]);
            }
        })
        .catch(e => {
            const errorMessage = getErrorMessage(e);
            setErrorMessage(errorMessage);
        })
        .finally(() => {
            setIsDataLoading(false);
        });
    }, [getErrorMessage]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const handleFinish = useCallback(() => {
        onSuccess({
            [communitySchema.name]: community,
            [communitySchema.isCenter]: isCenter
        })
    }, [onSuccess, community, isCenter]);

    useEffect(() => {
        if (isOpen) {
            if (defaultObject) {
                setCommunity(defaultObject[communitySchema.name]);
                setIsCenter(defaultObject[communitySchema.isCenter]);
            }
            else {
                setCommunity('');
                setIsCenter(false);
            }
        }
    }, [isOpen, defaultObject]);
    return (
        <SMCModal
            title={t('SMP.PLAN.SERVICES.VPN.COMMUNITY_WIZ.JOIN_COMMUNITY')}
            height={480}
            width={710}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            loading={isDataLoading}
            errorMessage={errorMessage}
            reloadData={loadData}
        >
            <SMCModalBody>
                <SMCLabel bold>{t('SMP.PLAN.SERVICES.VPN.COMMUNITY_WIZ.SELECT_COMMUNITY')}</SMCLabel>
                <SMCSelect
                    value={community}
                    onChange={e => setCommunity(e.target.value)}
                    label={t('SMP.PLAN.SERVICES.VPN.COMMUNITY_WIZ.COMMUNITY')}
                >
                    <SMCOption value=""></SMCOption>
                    {
                        communityNameList && communityNameList.map(commName => (
                            <SMCOption value={commName} key={commName}>{commName}</SMCOption>
                        ))
                    }
                </SMCSelect>
                {/* isCenter select, enable only if isGateway */}
                <SMCSelect
                    value={isCenter ? 'CENTER' : 'NORMAL'}
                    onChange={e => setIsCenter(e.target.value === 'CENTER')}
                    label={t('SMP.PLAN.SERVICES.VPN.COMMUNITY_WIZ.COMMUNITY')}
                    disabled={!isGateway}
                >
                    <SMCOption value='CENTER'>{t('SMP.PLAN.SERVICES.VPN.COMMUNITY_WIZ.MEMBER_TYPE.CENTER_GATEWAY')}</SMCOption>
                    <SMCOption value='NORMAL'>{t('SMP.PLAN.SERVICES.VPN.COMMUNITY_WIZ.MEMBER_TYPE.NORMAL')}</SMCOption>
                </SMCSelect>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={handleFinish} disabled={community === ''}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </SMCModal>
    );
}

export default JoinCommunityModal;